import React from "react";

import {
  BarProps,
  StackedLogDataPoint
} from "src/organization/pages/project/environment/metrics/logs/types";

import * as S from "./style";

const Bar = (props: BarProps<StackedLogDataPoint>) => {
  const handleMouseMove = e => {
    if (props.onMouseOver) {
      props.onMouseOver(e, props.data.data);
    }
  };

  return (
    <S.RectBar
      className="series"
      x={props.xScale(props.data.data.timestampDate)}
      y={props.yScale(props.data[1])}
      height={props.yScale(props.data[0]) - props.yScale(props.data[1])}
      width={props.xScale.bandwidth()}
      fill={props.fill}
      onMouseMove={handleMouseMove}
      onMouseLeave={props.onMouseLeave}
    ></S.RectBar>
  );
};

export default Bar;
